import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import ProtectedRoute from "./components/ProtectedRoute";
import AppShell from "./components/AppShell";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Employees from "./pages/Employees";
import KPITemplates from "./pages/KPITemplates";
import Evaluations from "./pages/Evaluations";
import NewEvaluation from "./pages/NewEvaluation";
import EvaluationDetail from "./pages/EvaluationDetail";
import CalendarPage from "./pages/CalendarPage";
import Coaching from "./pages/Coaching";
import Analytics from "./pages/Analytics";
import Bonus from "./pages/Bonus";
import SettingsPage from "./pages/SettingsPage";
import AuditLog from "./pages/AuditLog";
import EmployeeHistory from "./pages/EmployeeHistory";
import EvaluationCycleNew from "./pages/EvaluationCycleNew";
import ChangePassword from "./pages/ChangePassword";
import Users from "./pages/Users";
import { SuperAdminDashboard, SuperAdminTenants } from "./pages/SuperAdmin";
import TenantDetail from "./pages/TenantDetail";
import PlatformSettings from "./pages/PlatformSettings";
import { BrandingProvider } from "./lib/branding";

import "./App.css";

const shellRoutes = [
  { path: "/dashboard", el: <Dashboard /> },
  { path: "/positions", el: <Navigate to="/settings?tab=positions" replace />, roles: ["owner", "hr"] },
  { path: "/employees", el: <Employees />, roles: ["owner", "hr", "manager"] },
  { path: "/employees/:id", el: <EmployeeHistory />, roles: ["owner", "hr", "manager", "employee"] },
  { path: "/templates", el: <KPITemplates />, roles: ["owner", "hr"] },
  { path: "/evaluations", el: <Evaluations /> },
  { path: "/evaluations/cycles/new", el: <EvaluationCycleNew />, roles: ["owner", "hr", "manager"] },
  { path: "/evaluations/new", el: <NewEvaluation />, roles: ["owner", "hr", "manager"] },
  { path: "/evaluations/:id", el: <EvaluationDetail /> },
  { path: "/calendar", el: <CalendarPage />, roles: ["owner", "hr", "manager"] },
  { path: "/coaching", el: <Coaching />, roles: ["owner", "hr", "manager"] },
  { path: "/analytics", el: <Analytics />, roles: ["owner", "hr", "manager"] },
  { path: "/bonus", el: <Bonus />, roles: ["owner", "hr"] },
  { path: "/settings", el: <SettingsPage />, roles: ["owner", "hr"] },
  { path: "/audit-logs", el: <AuditLog />, roles: ["owner", "hr"] },
  { path: "/users", el: <Users />, roles: ["owner", "hr", "super_admin"] },
  { path: "/admin/dashboard", el: <SuperAdminDashboard />, roles: ["super_admin"] },
  { path: "/admin/tenants", el: <SuperAdminTenants />, roles: ["super_admin"] },
  { path: "/admin/tenants/:id", el: <TenantDetail />, roles: ["super_admin"] },
  { path: "/admin/settings", el: <PlatformSettings />, roles: ["super_admin"] },
];

function App() {
  return (
    <AuthProvider>
      <BrandingProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/change-password"
              element={
                <ProtectedRoute isPasswordGate>
                  <ChangePassword />
                </ProtectedRoute>
              }
            />
            {shellRoutes.map((r) => (
              <Route
                key={r.path}
                path={r.path}
                element={
                  <ProtectedRoute roles={r.roles}>
                    <AppShell>{r.el}</AppShell>
                  </ProtectedRoute>
                }
              />
            ))}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </BrandingProvider>
    </AuthProvider>
  );
}

export default App;
